/*
 * InsufficientFundsStyles.js
 *
 * @providesModule InsufficientFundsStyles
 * 
 */

import SkillzStyle from 'SkillzStyle';
import Sizes from 'Sizes';

import {
  StyleSheet,
} from 'react-native';

const {
  fontSizeH1,
  fontSizeH2,
  fontSizeH3,
  fontSizeH4,
  fontSizeH5,
  fontRegular,
  fontSecondary,
  textColorSecondary,
  viewCornerRadiusPrimary,
  viewBoxShadowPrimary,
} = SkillzStyle.fullStyles;

export default StyleSheet.create({
  header: {
    ...Sizes.select({
      landscapePhone: {
        flexDirection: 'row',
        alignItems:'center',
        justifyContent: 'center',
      },
      other: {
        marginTop: 10,
      },
    })
  },

  centerDialog: {
    justifyContent:'center',
    alignItems:'center',
  },

  contentBox: {
    flexDirection: 'column',
    backgroundColor: 'white',
    alignItems: 'center',
    justifyContent: 'center',
    ...viewCornerRadiusPrimary,
    ...viewBoxShadowPrimary,
  },

  headerText: {
    alignSelf:'center',
    textAlign: 'center',
    fontSize: Sizes.orientation({
      portrait: fontSizeH1.fontSize,
      landscape: fontSizeH2.fontSize,
    }),
    ...fontSecondary,
    ...textColorSecondary,
  },

  closeButton: {
    height: Sizes.dynamic({
      sm: 20,
      xxlg: 30,
    }),
    width:Sizes.dynamic({
      sm: 20,
      xxlg: 30,
    }),
    position:'absolute',
    top: 4,
    right: 4,
  },

  detailText: {
    marginVertical:5,
    paddingHorizontal:16,
    textAlign: 'center',
    fontSize: Sizes.orientation({
      portrait: fontSizeH3.fontSize,
      landscape: fontSizeH5.fontSize,
    }),
    ...fontRegular,
    ...textColorSecondary,
  },

  subheaderText: {
    textAlign: 'center',
    fontSize: Sizes.orientation({
      portrait: fontSizeH3.fontSize,
      landscape: fontSizeH4.fontSize,
    }),
    ...fontRegular,
    ...textColorSecondary,
  },
});
